export default __webpack_public_path__ + "static/media/Satish Chandra Vale.686526e5.jpg";